import {ModalTiteledWindow} from "./modalWindow.js";
import {DataView} from '../dataview.js';
import {ModalConfirm} from './modalConfirm.js';
import {ModalSelectPupil} from "./modalSelectPupil.js";

export class ModalEditCourse extends ModalTiteledWindow {

   constructor(courseId, dm) {
      super();
      this.dm = dm;


      const tmpl = document.getElementById('tpl-modal-edit-course');
      const container = tmpl.content.cloneNode(true);
      container.querySelector('.new-pupil').addEventListener('click', (event) => {
         event.stopPropagation();
         new ModalSelectPupil(
            { classes: Object.values(this.course.classes), ignore: Object.keys(this.course.pupils).map(id => parseInt(id)) },
            (pupils) => this.cbAddPupils(pupils),
            this.dm
         );
      });

      this.listPupils = new DataView(container.querySelector('.list'));

      this.appendToBody(container);

      this.loadCourse(courseId);
      setTimeout(() => this.show(), 1);

   }

   cbRemovePupil(pupil) {
      new ModalConfirm(`Soll <span class="hilight">${pupil.firstName} ${pupil.lastName}</span> wirklich aus dem Kurs entfernt werden?`, async (confirm) => {
         if (confirm) {
            await this.dm.courseRemovePupil(this.course.id, pupil.id);
            this.loadCourse(this.course.id);
         }
      });
   }

   async cbAddPupils(pupils) {
      await this.dm.courseAddPupils(this.course.id, pupils);
      this.loadCourse(this.course.id);
   }

   loadCourse(courseId) {

      this.course = this.dm.getCourse(courseId);
      this.setTitle(`${this.course.classNames} ${this.course.short} (${Object.values(this.course.pupils).length} SuS)`);

      let pupils = [];

      for (let pupil of this.course.pupils) {
         pupils.push(this.dm.getPupil(pupil));
      }

      var listSettings = {
         columns: [
            {
               title: '',
               data: [
                  {
                     type: 'button',
                     label: (pupil) => { return HTMLElement.createFromHTML('<i class="icon-cross"></i>'); },
                     onClick: (pupil) => this.cbRemovePupil(pupil),
                     css: () => { return { 'font-size': '2rem' }; }
                  },
               ]
            },
            {
               title: 'Nachname',
               data: 'lastName',
               sort: { index: 1, dir: 1 }
            },
            {
               title: 'Vorname',
               data: 'firstName',
               sort: { index: 2, dir: 1 }
            },
            {
               title: 'Klasse',
               data: (pupil) => {
                  return pupil.class.name;
               },
               sort: { index: 3, dir: 1 }
            }
         ],
         showHeader: true,

         onSelected: (course) => {

         }

      };

      this.listPupils.load(pupils, listSettings);

   }

}
